/**
 * Editorial copy for the /sobre page. Kept here (not inlined in
 * components) so the chapter narrative can be revised without
 * touching layout, and so it can move into i18n later.
 *
 * Source: old site /about-us (patinhassemlar.org) — operational
 * pillars adapted verbatim into the chapter aesthetic. Mission
 * pillars on Home (`Mission.tsx`) stay narrative — these are the
 * complementary "o que fazemos, ao certo" set.
 */

export interface OpsPillar {
  num: string;
  title: string;
  body: string;
  note?: string;
}

export const ABOUT_INTRO = {
  chapter: 'Cap. V · A nossa associação',
  label:
    'Um caderno mais antigo, com páginas de 2013 e dobras pelo meio. Continuamos a escrever — devagar, com cuidado.',
  head: {
    line1: 'Pequena, perto do mar,',
    emphasis: 'cuidadosa.',
  },
};

export const HISTORY = {
  // We leave the exact founding-year phrasing soft until the President
  // confirms. What we can say with confidence: legal constitution 2013,
  // shelter in Silvalde from 2019, current direção empossada em 2025.
  kicker: '— como começámos',
  paragraphs: [
    'A Patinhas Sem Lar nasceu em 2013 — papéis em ordem, estatutos assinados, um nome no Diário da República. O canil em Silvalde abriu portas em 2019, depois de a Câmara de Espinho ceder o terreno. O gatil em Espinho cresceu pouco depois, num espaço a poucos minutos do canil.',
    'Não somos uma associação grande. Somos uma associação devagar. Cuidamos de poucos animais de cada vez, com tempo para os conhecer e para os entregar bem. A maior parte do que fazemos é invisível: refeições, banhos, idas ao veterinário, voltas de coleira ao fim do dia.',
  ],
  marginNote: '— desde 2013 · com calma.',
};

export const VALUES = {
  kicker: '— em que acreditamos',
  head: {
    line1: 'Compromisso',
    emphasis: 'com os animais.',
  },
  body:
    'Somos uma associação feita de pessoas que acreditam que todos os animais têm direito a uma vida com dignidade. Trabalhamos com o que temos — tempo, mãos, recursos — e sabemos que cada gesto conta.',
  handNote: '— cada gesto, mesmo o pequeno.',
};

export const VISION = {
  kicker: '— para onde olhamos',
  head: 'Um mundo em que todos os animais têm uma família.',
  body:
    'Um futuro em que os animais sejam reconhecidos como vidas que importam — com espaço para cuidado, acolhimento, e soluções para além do abandono.',
};

export const OPS_PILLARS_INTRO = {
  chapter: '— o que fazemos, ao certo',
  label:
    'Tratar dos animais. Cuidar e proteger — quatro coisas a fazer todos os dias.',
};

export const OPS_PILLARS: OpsPillar[] = [
  {
    num: '1',
    title: 'Acolhimento',
    body:
      'Oferecer um lar temporário seguro para animais em situação de abandono, garantindo-lhes conforto, carinho e proteção.',
    note: '— um lugar onde respirar.',
  },
  {
    num: '2',
    title: 'Cuidados veterinários',
    body:
      'Assegurar o bem-estar físico e emocional, com acompanhamento veterinário, vacinação, desparasitação e, quando necessário, tratamentos médicos.',
    note: '— sem atalhos, nunca.',
  },
  {
    num: '3',
    title: 'Alimentação',
    body:
      'Garantir uma alimentação adequada, adaptada a cada animal, respeitando as suas necessidades específicas.',
    note: '— ração própria para cada idade.',
  },
  {
    num: '4',
    title: 'Adoção responsável',
    body:
      'Promover a adoção consciente, ligando os nossos patudos a famílias responsáveis que lhes proporcionem amor e segurança duradouros.',
    note: '— para a vida, mesmo.',
  },
];
